<script>
import options from './MemberOverlayProfileCard.options'
export default options
</script>

<template>
  <div class="kb-overlay-styles__content-wrapper">

    <article class="kb-member-overlay kb-member-overlay-profile-card" :class="{ 'kb-member-overlay--submitting': isSubmitting }">
      <div v-if="memberDataFetched" class="kb-overlay-styles__wrapper-for-scroll-bottom">

        <div class="kb-member-overlay__hero-wrapper">
          <figure class="kb-image-module kb-image-module--1-1 kb-member-overlay__member-profile-img">
            <div class="kb-image-module__image-container">
              <picture class="kb-image-module__image">
                <img :src="memberData.imageSrc" :alt="memberData.imageAlt" />
              </picture>
            </div>
          </figure>

          <p class="kb-member-overlay__member-name">
            {{ memberData.name }}
          <div class="kb-member-overlay__member-roles-wrapper">
            <template v-for="(memberRole, index) in memberData.memberRoles" :key="index">
              <span class="kb-member-overlay__member-role">
                {{ memberRole }}
              </span>
            </template>
          </div>
          </p>

        </div>
        <div class="kb-member-overlay__hero-curve">
          <svg role="presentation" viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
          </svg>
        </div>

        <section class="kb-member-overlay__member-details">
          <p class="kb-member-overlay__member-details-profile-text">
            <template v-for="(line, index) in formatNewlines(memberData.profileText)" :key="index">
              <br v-if="index > 0">{{ line }}
            </template>
          </p>
          <div class="kb-member-overlay__member-details-divider"></div>
          <ul class="kb-member-overlay__member-details-list">
            <template v-for="(memberDetails, index) in memberData.details" :key="index">
              <li>
                <p> {{ memberDetails.label }}</p>
                <p> {{ memberDetails.detail }}</p>
              </li>
            </template>
          </ul>
          <div class="kb-member-overlay__member-details-divider"></div>

          <a :href="memberData.answerLink" class="kb-button kb-button--full-color-spot"> {{
            getLabel('writeMessageButtonText') }}</a>
        </section>

      </div>

      <template v-if="isSubmitting">
        <div class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
        </div>
      </template>
    </article>

  </div>
</template>
